var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-validate"},[_c('van-field',{attrs:{"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }